import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from "react-paginate";
function QbsconnectTalkComp() {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem('key'));
  const pagination = useRef();
  const [perPage, setPerpage] = useState('');
  const [totalitem, setTotalitem] = useState('');
  const [tasllist, setTalklist] = useState([])

  const [tab1, setTab1] = useState(true);
  const [tab2, setTab2] = useState(false);
  const [tab3, setTab3] = useState(false);

  const get_oermission_data = useSelector((state) => state);
  const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
  const hr_permission = get_oermission_data.login_Permission.permissions

  useEffect(() => {
    getTalk()
    getClientFeedback()
  }, [])
  const setPage = ({ selected }) => {
    getTalk(selected + 1);
  }
  const getTalk = async (page) => {
    const response = await fetch(SERVER_URL + `api/employee/talk/feedback-suggestion-list?page=${page}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      }).then(res => res.json())
      .then(data => {
        setTalklist(data.talk)
        setTotalitem(data.talkTotal[0].Total);
        setPerpage(data.limit)
      })
  }
  const [clientBeedbacklist, setClientBeedbacklist] = useState([])
  const getClientFeedback = async (page) => {
    const response = await fetch(SERVER_URL + `api/employee/client/client-feedback-suggestion-list?page=${page}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      }).then(res => res.json())
      .then(data => {
        // console.log(data)
        setClientBeedbacklist(data.client)
        // setClientBeedbacklist(data.clientTotal[0].Total);
        // setPerpage(data.limit)
      })
  }
  const handelDelete = (id) => {
    alert(id)
  }
  const handelEdit = (id) => {
    alert(id)
  }
  const handleTab = (tab) => {
    if (tab == 1) {
      setTab1(true)
      setTab2(false)
      setTab3(false)
    } else if (tab == 2) {
      setTab1(false)
      setTab2(true)
      setTab3(false)
    } else if (tab == 3) {
      setTab1(false)
      setTab2(false)
      setTab3(true)
    }
  }
  return (
    <>
      <div className="page-header">
        <h1>
          {/* <button className="btn_5 mt05 float-end" >Add Quote</button> */}
          QBS Connect talk</h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <a href="dashboard.html">Dashboard </a>
          </li>
          <li className="current">
            <span>/</span> QBS Connect talk
          </li>
        </ul>
      </div>
      <div className="row_bg">
        <div className="row mb30 content_wrp1">
          <div className="col-md-12">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <button className={`nav-link ${tab1 ? 'active' : ''}`} onClick={() => { handleTab(1) }}>QBS Connect Talk</button>
              </li>
              <li className="nav-item">
                <button className={`nav-link ${tab3 ? 'active' : ''}`} onClick={() => { handleTab(3) }}>Client Feedback</button>
              </li>
              <li className="nav-item">
                <button className={`nav-link ${tab2 ? 'active' : ''}`} onClick={() => { handleTab(2) }}>Portal Suggestion</button>
              </li>

            </ul>
            <div className="tab-content tab_wrapper">
              <div id="tabs1" className={`tab-pane ${tab1 ? 'active' : ''}`}>
                <table className="table_style_1">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Talk</th>
                      <th>Message</th>
                      <th>Status</th>
                      <th style={{ width: '150' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      tasllist.map((item, ind) => {
                        return <tr key={ind}>
                          <td>{ind + 1}</td>
                          <td>{item.title}</td>
                          <td>{item.message}</td>
                          <td>{item.status == 1 ? <span className='active'>Active</span> : <span>Inactive</span>}</td>
                          <td>
                            {
                              (hr_permission?.includes('42') && <button className="btn_7 mr03" onClick={(e) => { handelEdit(item.id) }}>Edit</button>)
                            }
                            {
                              (hr_permission?.includes('43') && <button className="btn_8" onClick={(e) => { handelDelete(item.id) }}>Delete</button>)
                            }
                          </td>
                        </tr>
                      })
                    }
                  </tbody>
                  <tfoot>
                    <tr><td colSpan="8" >
                      <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                      <ReactPaginate
                        ref={pagination}
                        pageCount={Math.ceil(totalitem / perPage)}
                        pageRangeDisplayed={4}
                        marginPagesDisplayed={1}
                        onPageChange={setPage}
                        containerClassName="pagination"
                        activeClassName="active"
                        pageLinkClassName="page-link"
                        breakLinkClassName="page-link"
                        nextLinkClassName="page-link"
                        previousLinkClassName="page-link"
                        pageClassName="page-item"
                        breakClassName="page-item"
                        nextClassName="page-item"
                        previousClassName="page-item"
                        previousLabel={<>&laquo;</>}
                        nextLabel={<>&raquo;</>}
                      />
                    </td></tr>
                  </tfoot>
                </table>
              </div>
              <div id="tabs3" className={`tab-pane ${tab3 ? 'active' : ''}`}>
                <table className="table_style_1">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Title</th>
                      <th>Message</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      clientBeedbacklist?.map((item, ind) => <tr key={ind}>
                        <td>{item.id}</td>
                        <td>{item.title}</td>
                        <td>{item.message}</td>
                        <td>{item.status == 1 ? "active" : "Inactive"}</td>
                        <td></td>
                      </tr>)
                    }</tbody>
                </table>
              </div>
              <div id="tabs2" className={`tab-pane ${tab2 ? 'active' : ''}`}>
                <table className="table_style_1">
                  <thead>
                    <tr>
                      <th>Employee Code</th>
                      <th>Employee Name</th>
                      <th>Department </th>
                      <th>Designation	</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2490</td>
                      <td><span className="avatar_icon">VY</span> Vibha Yadav</td>
                      <td>Software</td>
                      <td>UI Designer</td>
                      <td>Active</td>
                      <td>
                        <button className="btn_7 mr03">Edit</button>
                        <button className="btn_8">Delete</button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        2489
                      </td>
                      <td><span className="avatar_icon">DP</span> Diwakar Pandey</td>
                      <td>Software</td>
                      <td>UI Designer</td>
                      <td>Active</td>
                      <td>
                        <button className="btn_7 mr03">Edit</button>
                        <button className="btn_8">Delete</button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        2488
                      </td>
                      <td><span className="avatar_icon">SU</span> Shrikant Upadhyay</td>
                      <td>Software</td>
                      <td>UI Designer</td>
                      <td>Active</td>
                      <td>
                        <button className="btn_7 mr03">Edit</button>
                        <button className="btn_8">Delete</button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        2490
                      </td>
                      <td><span className="avatar_icon">VY</span> Vibha Yadav</td>
                      <td>Software</td>
                      <td>UI Designer</td>
                      <td>Active</td>
                      <td>
                        <button className="btn_7 mr03">Edit</button>
                        <button className="btn_8">Delete</button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        2489
                      </td>
                      <td><span className="avatar_icon">DP</span> Diwakar Pandey</td>
                      <td>Software</td>
                      <td>UI Designer</td>
                      <td>Active</td>
                      <td>
                        <button className="btn_7 mr03">Edit</button>
                        <button className="btn_8">Delete</button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        2488
                      </td>
                      <td><span className="avatar_icon">SU</span> Shrikant Upadhyay</td>
                      <td>Software</td>
                      <td>UI Designer</td>
                      <td>Active</td>
                      <td>
                        <button className="btn_7 mr03">Edit</button>
                        <button className="btn_8">Delete</button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        2490
                      </td>
                      <td><span className="avatar_icon">VY</span> Vibha Yadav</td>
                      <td>Software</td>
                      <td>UI Designer</td>
                      <td>Active</td>
                      <td>
                        <button className="btn_7 mr03">Edit</button>
                        <button className="btn_8">Delete</button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        2489
                      </td>
                      <td><span className="avatar_icon">DP</span> Diwakar Pandey</td>
                      <td>Software</td>
                      <td>UI Designer</td>
                      <td>Active</td>
                      <td>
                        <button className="btn_7 mr03">Edit</button>
                        <button className="btn_8">Delete</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default QbsconnectTalkComp
